// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-page {
  max-width: 800px;
  margin: 0 auto;
}

.progress-page h1 {
  margin-bottom: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.big-stat-card {
  background: white;
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.big-stat-card.points {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
}

.big-stat-card.streak {
  background: linear-gradient(135deg, #FF6B6B, #FF8E53);
  color: white;
}

.big-stat-card.words {
  background: linear-gradient(135deg, #4CAF50, #8BC34A);
  color: white;
}

.big-stat-card.lessons {
  background: linear-gradient(135deg, #2196F3, #03A9F4);
  color: white;
}

.big-stat-icon {
  font-size: 40px;
  margin-bottom: 8px;
}

.big-stat-value {
  font-size: 48px;
  font-weight: 800;
}

.big-stat-label {
  font-size: 14px;
  opacity: 0.9;
}

.today-card {
  text-align: center;
  margin-bottom: 16px;
}

.today-card h3 {
  margin-bottom: 12px;
}

.today-points {
  font-size: 32px;
  font-weight: 800;
  color: var(--primary);
}

.tips-card h3 {
  margin-bottom: 12px;
}

.tips-card ul {
  list-style: none;
  padding: 0;
}

.tips-card li {
  padding: 8px 0;
  font-size: 16px;
  border-bottom: 1px solid var(--border);
}

.tips-card li:last-child {
  border-bottom: none;
}

@media (max-width: 600px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Progress.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".progress-page {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.progress-page h1 {\n  margin-bottom: 24px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.big-stat-card {\n  background: white;\n  border-radius: 20px;\n  padding: 24px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.big-stat-card.points {\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #333;\n}\n\n.big-stat-card.streak {\n  background: linear-gradient(135deg, #FF6B6B, #FF8E53);\n  color: white;\n}\n\n.big-stat-card.words {\n  background: linear-gradient(135deg, #4CAF50, #8BC34A);\n  color: white;\n}\n\n.big-stat-card.lessons {\n  background: linear-gradient(135deg, #2196F3, #03A9F4);\n  color: white;\n}\n\n.big-stat-icon {\n  font-size: 40px;\n  margin-bottom: 8px;\n}\n\n.big-stat-value {\n  font-size: 48px;\n  font-weight: 800;\n}\n\n.big-stat-label {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.today-card {\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.today-card h3 {\n  margin-bottom: 12px;\n}\n\n.today-points {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--primary);\n}\n\n.tips-card h3 {\n  margin-bottom: 12px;\n}\n\n.tips-card ul {\n  list-style: none;\n  padding: 0;\n}\n\n.tips-card li {\n  padding: 8px 0;\n  font-size: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.tips-card li:last-child {\n  border-bottom: none;\n}\n\n@media (max-width: 600px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
